import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Form,
} from "reactstrap"
import Select from "react-select"
import { useNavigate, useParams } from "react-router-dom"
import { useFormik } from "formik" // added
import * as Yup from "yup"

// Import Images
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import {
  CREATE_ORDER_AWARD_NOMINATION_RESET,
  RESET_AWARD_BILLING,
  VERIFY_AWARD_NOMINATION_PAYMENT_RESET,
} from "../../../redux/types/awards"
import moment from "moment"
import {
  createOrderAwardNomination,
  verifyAwardNominationPayment,
} from "../../../redux/actions/awards"
import ProfileMenu from "components/CommonForBoth/TopbarDropdown/ProfileMenu"
import PageLoader from "components/Common/PageLoader"

const stateOptions = [
  {
    options: [
      {
        label: "Andaman and Nicobar Islands",
        value: 4023,
      },
      {
        label: "Andhra Pradesh",
        value: 4017,
      },
      {
        label: "Arunachal Pradesh",
        value: 4024,
      },
      {
        label: "Assam",
        value: 4027,
      },
      {
        label: "Bihar",
        value: 4037,
      },
      {
        label: "Chandigarh",
        value: 4031,
      },
      {
        label: "Chhattisgarh",
        value: 4040,
      },
      {
        label: "Dadra and Nagar Haveli and Daman and Diu",
        value: 4033,
      },
      {
        label: "Delhi",
        value: 4021,
      },
      {
        label: "Goa",
        value: 4009,
      },
      {
        label: "Gujarat",
        value: 4030,
      },
      {
        label: "Haryana",
        value: 4007,
      },
      {
        label: "Himachal Pradesh",
        value: 4020,
      },
      {
        label: "Jammu and Kashmir",
        value: 4029,
      },
      {
        label: "Jharkhand",
        value: 4025,
      },
      {
        label: "Karnataka",
        value: 4026,
      },
      {
        label: "Kerala",
        value: 4028,
      },
      {
        label: "Ladakh",
        value: 4852,
      },
      {
        label: "Lakshadweep",
        value: 4019,
      },
      {
        label: "Madhya Pradesh",
        value: 4039,
      },
      {
        label: "Maharashtra",
        value: 4008,
      },
      {
        label: "Manipur",
        value: 4010,
      },
      {
        label: "Meghalaya",
        value: 4006,
      },
      {
        label: "Mizoram",
        value: 4036,
      },
      {
        label: "Nagaland",
        value: 4018,
      },
      {
        label: "Odisha",
        value: 4013,
      },
      {
        label: "Puducherry",
        value: 4011,
      },
      {
        label: "Punjab",
        value: 4015,
      },
      {
        label: "Rajasthan",
        value: 4014,
      },
      {
        label: "Sikkim",
        value: 4034,
      },
      {
        label: "Tamil Nadu",
        value: 4035,
      },
      {
        label: "Telangana",
        value: 4012,
      },
      {
        label: "Tripura",
        value: 4038,
      },
      {
        label: "Uttar Pradesh",
        value: 4022,
      },
      {
        label: "Uttarakhand",
        value: 4016,
      },
      {
        label: "West Bengal",
        value: 4853,
      },
    ],
  },
]

// GSTIN (15 chars) regex — 2 digits (state) + 10-char PAN + 1 entity char + 'Z' + checksum
const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/i

const AwardBillingDetails = () => {
  document.title = "Awards Billing"

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [showCoupon, setShowCoupon] = useState(false)
  const [appliedCoupon, setAppliedCoupon] = useState(null)
  const [couponCode, setCouponCode] = useState(null)
  const [appliedCouponError, setAppliedCouponError] = useState(null)
  const [gstAvailable, setGstAvailable] = useState(false)
  const [userShortlisted, setUserShortlisted] = useState(false)
  const [tncAccepted, setTncAccepted] = useState(false)

  const token = useSelector(state => state.auth.token)
  const user = useSelector(state => state.auth.user)
  const awardDetails = useSelector(state => state.awards.awardDetails)
  const awards = useSelector(state => state.auth.awards)
  const dashboardData = useSelector(state => state.auth.dashboardData) || {}
  const activeAwardUrl =
    dashboardData.active_award && dashboardData.active_award.length > 0
      ? dashboardData.active_award[0].url
      : ""
  const encAwardNominationId = useSelector(
    state => state.awards.encAwardNominationId
  )
  const nominationOrderDetails = useSelector(
    state => state.awards.nominationOrderDetails
  )
  const createOrderAwardNominationScreen = useSelector(
    state => state.screens.awards.createOrderAwardNomination
  )
  const verifyAwardNominationPaymentScreen = useSelector(
    state => state.screens.awards.verifyAwardNominationPayment
  )

  useEffect(() => {
    console.log("nomination id....", encAwardNominationId)
  }, [encAwardNominationId])

  let subtotal = 3000
  let tax = 540
  let total = 3540
  if (userShortlisted) {
    subtotal = 9000
    tax = 1800
    total = 10800
  }

  const toggleCoupon = () => {
    setShowCoupon(prev => !prev)
  }

  useEffect(() => {
    console.log('award billing details invoked and checking awards data....', awards);
    
    if (awards && awards.length > 0) {
      if (awards[0].status === "shortlisted") {
        setUserShortlisted(true)
      }
    } else {
      navigate("/awards/" + activeAwardUrl, { replace: true })
    }
  }, [awards])

  useEffect(() => {
    if (createOrderAwardNominationScreen.success) {
      dispatch({ type: CREATE_ORDER_AWARD_NOMINATION_RESET })
      // handlepayment()
    }
    if (createOrderAwardNominationScreen.error) {
      toast.error(createOrderAwardNominationScreen.error)
      dispatch({ type: CREATE_ORDER_AWARD_NOMINATION_RESET })
    }
  }, [createOrderAwardNominationScreen])

  useEffect(() => {
    if (verifyAwardNominationPaymentScreen.success) {
      toast.success(verifyAwardNominationPaymentScreen.message)
      dispatch({ type: VERIFY_AWARD_NOMINATION_PAYMENT_RESET })
      dispatch({ type: RESET_AWARD_BILLING })
      navigate("/nominee-booking-confirm", { replace: true })
    }
    if (verifyAwardNominationPaymentScreen.error) {
      toast.error(verifyAwardNominationPaymentScreen.error)
      dispatch({ type: VERIFY_AWARD_NOMINATION_PAYMENT_RESET })
    }
  }, [verifyAwardNominationPaymentScreen])

  useEffect(() => {
    if (nominationOrderDetails) {
      handlepayment()
    }
  }, [nominationOrderDetails])

  useEffect(() => {
    if (user) {
      billingDetails.setValues({
        firstName: user.first_name || "",
        lastName: user.last_name || "",
        companyName: user.company_name || "",
        address: user.address || "",
        city: user.city || "",
        state: user.state
          ? stateOptions[0].options.find(val => val.label === user.state)
          : null,
        pincode: user.pincode || "",
        gstNumber: user.gst_number || "",
        email: user.email_id || "",
        mobileNo: user.mobile_no || "",
      })
      if (user.gst_number) setGstAvailable(true)
    }
  }, [user])

  const applyCoupon = async () => {
    if (couponCode === null || (couponCode && couponCode.trim() === "")) {
      setAppliedCouponError("Please enter a coupon code")
      return
    }
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/events/apply-coupon`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            coupon: couponCode,
          }),
        }
      )
      const data = await res.json()

      if (data.success) {
        setAppliedCoupon({
          coupon_id: data.coupon_id,
          coupon: data.coupon,
          discount_percent: data.discount_percent,
        })
      } else {
        setAppliedCouponError(data.message)
      }
    } catch (err) {
      console.error(err)
      setAppliedCouponError("Failed to apply coupon")
    }
  }

  const removeCoupon = () => {
    setAppliedCoupon(null)
    setAppliedCouponError(null)
  }

  const handlepayment = () => {
    const options = {
      key: process.env.REACT_APP_RZRPAY_KEY,
      amount: nominationOrderDetails.amount,
      currency: nominationOrderDetails.currency,
      name: "Award Payment",
      description: "Awards nomination payment",
      order_id: nominationOrderDetails.id,
      receipt: nominationOrderDetails.receipt,

      handler: async function (response) {
        // Call your backend to verify payment and update booking status
        // try {
        // toast.success("🎉 Payment successful!")
        // history("/congratulations", { replace: true })
        let requestData = {
          razorpay_order_id: response.razorpay_order_id,
          razorpay_payment_id: response.razorpay_payment_id,
          razorpay_signature: response.razorpay_signature,
          subtotal: subtotal, //basic price
          tax: tax, // tax amount
          total: total, // basic price + tax amount
          currency: "INR",
          enc_award_nomination_id: encAwardNominationId,
          award_step: userShortlisted ? 2 : 1,
        }
        dispatch(verifyAwardNominationPayment(requestData))
        // } catch (err) {
        //   // setPaymentLoader(false)
        //   alert(
        //     "Payment received, but verification failed. Please contact support."
        //   )
        // }
      },
      modal: {
        ondismiss: () => {
          // setPaymentLoader(false)
          toast.info("Payment cancelled.")
        },
      },
      prefill: {
        email: user && user.email_id ? user.email_id : "",
      },
      theme: {
        color: "#3399cc",
      },
    }

    if (window.Razorpay) {
      const rzp = new window.Razorpay(options)
      // 🔴 Card declined, 3‑DS failure, etc.
      rzp.on("payment.failed", err => {
        setPaymentLoader(false)
        console.error("Payment failed:", err.error.description)
        toast.error("❌ Payment failed. Please try again.")
      })

      // Optional: network/SDK load errors
      rzp.on("payment.error", err => {
        setPaymentLoader(false)
        toast.error("Payment could not be completed.")
      })

      rzp.open()
    } else {
      alert(
        "Payment gateway not loaded. Please refresh the page and try again."
      )
    }
  }

  const billingDetails = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      companyName: "",
      address: "",
      city: "",
      state: null,
      pincode: "",
      gstNumber: "",
      email: "",
      mobileNo: "",
    },
    validationSchema: Yup.object({
      firstName: Yup.string().required("Please Enter Your Full Name"),
      companyName: Yup.string().required("Please Enter Your Company Name"),
      email: Yup.string()
        .email("Invalid Email Id")
        .required("Please Enter Your Email Id"),
      mobileNo: Yup.string().required("Please Enter Your Mobile No"),
      gstNumber: Yup.string().matches(gstRegex, "Invalid GST Number format"),
    }),
    onSubmit: values => {

      let requestData = {
        subtotal: subtotal, //basic price
        tax: tax, // tax amount
        total: total, // basic price + tax amount
        currency: "INR",
        enc_award_nomination_id: encAwardNominationId,
        award_step: userShortlisted ? 2 : 1,
        billingDetails: {
          invoice_date: moment().format("YYYY-MM-DD"), //Mandatory - By deafult select today date
          first_name: values.firstName,
          last_name: values.lastName,
          mobile_no: values.mobileNo,
          email_id: values.email,
          gst_number: values.gstNumber,
          company_name: values.companyName,
          address: values.address,
          city: values.city,
          state: values.state ? values.state.label : "",
          pincode: values.pincode,
        },
      }
      dispatch(createOrderAwardNomination(requestData))
    },
  })

  return (
    <div className="page-content" style={{ paddingLeft: 0, paddingRight: 0 }}>
      <div
        className="container-fluid"
        style={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <div className="newaward-maincontainer p-4">
          <Container fluid>
            <Form
              onSubmit={e => {
                e.preventDefault()
                billingDetails.handleSubmit()
                return false
              }}
            >
              <Row className="award-billing-wrapform">
                <Col xs={12} xl={8}>
                  <Card>
                    <CardBody>
                      <h2 className="nom-title">Billing Details</h2>
                      <div className="border-top mb-1 pb-2"></div>
                      {/* Primary Contact */}
                      <div className="mb-3 row mt-3">
                        <div className="col-12 col-sm-3">
                          <Label
                            className="form-label"
                            htmlFor="primary_contact"
                          >
                            Primary Contact &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm">
                          <div className="row">
                            <div className="col-12 col-sm-6 mb-3">
                              <Input
                                name="firstName"
                                className="form-control"
                                placeholder="First Name"
                                type="text"
                                id="first_name"
                                value={billingDetails.values.firstName}
                                onChange={billingDetails.handleChange}
                              />
                              {billingDetails.errors.firstName && (
                                <div className="text-danger small mt-1">
                                  {billingDetails.errors.firstName}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-6">
                              <Input
                                name="lastName"
                                className="form-control"
                                placeholder="Last Name"
                                id="last_name"
                                type="text"
                                value={billingDetails.values.lastName}
                                onChange={billingDetails.handleChange}
                              />
                              {billingDetails.errors.lastName && (
                                <div className="text-danger small mt-1">
                                  {billingDetails.errors.lastName}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Contact Info */}
                      <div className="mb-3 row mt-3">
                        <div className="col-12 col-sm-3">
                          <Label
                            className="form-label"
                            htmlFor="primary_contact"
                          >
                            Contact Info &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm">
                          <div className="row">
                            <div className="col-12 col-sm-6 mb-3">
                              <Input
                                name="email"
                                className="form-control"
                                type="email"
                                id="emailr"
                                value={billingDetails.values.email}
                                onChange={billingDetails.handleChange}
                              />
                              {billingDetails.errors.email && (
                                <div className="text-danger small mt-1">
                                  {billingDetails.errors.email}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-6">
                              <Input
                                name="mobileNo"
                                className="form-control"
                                type="number"
                                id="Mob_number"
                                value={billingDetails.values.mobileNo}
                                onChange={billingDetails.handleChange}
                              />
                              {billingDetails.errors.mobileNo && (
                                <div className="text-danger small mt-1">
                                  {billingDetails.errors.mobileNo}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Company Name */}
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="company_name">
                            Company Name &nbsp;
                            <span className="text-danger">*</span>
                          </Label>
                        </div>
                        <div className="col-12 col-sm-9">
                          <Input
                            name="companyName"
                            className="form-control"
                            type="text"
                            id="company_name"
                            value={billingDetails.values.companyName}
                            onChange={billingDetails.handleChange}
                          />
                          {billingDetails.errors.companyName && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.companyName}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* Address textarea */}
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="address">
                            Address &nbsp;
                          </Label>
                        </div>
                        <div className="col-12 col-sm-9">
                          <textarea
                            name="address"
                            className="form-control"
                            id="address"
                            rows="3"
                            value={billingDetails.values.address}
                            onChange={billingDetails.handleChange}
                          ></textarea>
                          {billingDetails.errors.address && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.address}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* City & State */}
                      <div className="mb-3 row mt-3">
                        <div className="col-12 col-sm-3">
                          <Label
                            className="form-label"
                            htmlFor="primary_contact"
                          >
                            City & State &nbsp;
                          </Label>
                        </div>
                        <div className="col-12 col-sm">
                          <div className="row">
                            <div className="col-12 col-sm-6 mb-3">
                              <Input
                                name="city"
                                className="form-control"
                                type="text"
                                id="city"
                                value={billingDetails.values.city}
                                onChange={billingDetails.handleChange}
                              />
                              {billingDetails.errors.city && (
                                <div className="text-danger small mt-1">
                                  {billingDetails.errors.city}
                                </div>
                              )}
                            </div>
                            <div className="col-12 col-sm-6">
                              <Select
                                name="state"
                                value={billingDetails.values.state}
                                onChange={val => {
                                  billingDetails.setFieldValue("state", val)
                                }}
                                options={stateOptions}
                                classNamePrefix="select2-selection"
                              />
                              {billingDetails.errors.state && (
                                <div className="text-danger small mt-1">
                                  {billingDetails.errors.state}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Pincode */}
                      <div className="mb-3 row">
                        <div className="col-12 col-sm-3">
                          <Label className="form-label" htmlFor="company_name">
                            Pin Code &nbsp;
                          </Label>
                        </div>
                        <div className="col-12 col-sm-5">
                          <Input
                            name="pincode"
                            className="form-control"
                            type="number"
                            id="pincode"
                            value={billingDetails.values.pincode}
                            onChange={billingDetails.handleChange}
                          />
                          {billingDetails.errors.pincode && (
                            <div className="text-danger small mt-1">
                              {billingDetails.errors.pincode}
                            </div>
                          )}
                        </div>
                      </div>
                      {/* GST Number */}
                      <div className="gst-row mb-4">
                        <div className="gst-header d-flex gap-3 align-items-center">
                          <Label className="form-label mb-0">
                            GST Number{" "}
                            <span className="optional">(optional)</span>
                          </Label>

                          {!gstAvailable ? (
                            <button
                              type="button"
                              className="btn btn-link gst-toggle-btn"
                              onClick={() => setGstAvailable(true)}
                            >
                              + Add GST
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-link gst-toggle-btn text-danger"
                              onClick={() => {
                                setGstAvailable(false)
                                billingDetails.setFieldValue("gstNumber", "")
                              }}
                            >
                              ✕ Remove
                            </button>
                          )}
                        </div>

                        <div
                          className={`gst-input-container ${
                            gstAvailable ? "open" : ""
                          }`}
                        >
                          <Input
                            name="gstNumber"
                            id="gstNumber"
                            placeholder="Enter your GST Number"
                            value={billingDetails.values.gstNumber}
                            onChange={billingDetails.handleChange}
                            onBlur={billingDetails.handleBlur}
                            invalid={
                              billingDetails.touched.gstNumber &&
                              billingDetails.errors.gstNumber
                            }
                          />
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs={12} xl={4}>
                  <Card className="p-4 rightform">
                    <div>
                      <div className="amount-box">
                        <div className="workshop-box pb-2 ">
                          <h3 className="nom-title">Award Details</h3>
                          <div className="gst-row"></div>
                          <h4 className="h4">{awardDetails.subtitle}</h4>
                        </div>
                        <div className="no-tickets pt-3 pb-2">
                          <div id="ticket-details">
                            <div className="amount-list float-start w-100 d-flex border-bottom">
                              <div>
                                <h3 className="card-title">Nomination Fee</h3>
                              </div>
                              <input
                                type="hidden"
                                name="nomination_fee"
                                value={3000}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="ticket-totals">
                        <div className="grand-total float-start w-100 mt-2">
                          <div className="float-start">
                            <h3 className="font-weight-bold font-size-16">
                              Total
                            </h3>
                          </div>
                          <div className="float-end">
                            <p>{`₹ ${subtotal}`}</p>
                          </div>
                        </div>
                        <div className="grand-total float-start w-100 mt-1 ">
                          <div className="float-start">
                            <h3 className="font-weight-bold font-size-16">
                              GST (18%)
                            </h3>
                          </div>
                          <div className="float-end">
                            <p>{`₹ ${tax}`}</p>
                          </div>
                        </div>

                        <div className="grand-total float-start w-100 mt-1 border-bottom">
                          <div className="float-start">
                            <h3 className="font-weight-bold font-size-16">
                              Grand Total
                            </h3>
                          </div>
                          <div className="float-end">
                            <p>
                              <b>{`₹ ${total}`}</b>
                            </p>
                          </div>
                          {appliedCoupon && (
                            <div className="grand-total float-start w-100 ">
                              <div className="float-start">
                                <h3 className="font-weight-bold font-size-16 text-success">
                                  Discount Applied (
                                  {appliedCoupon.discount_percent}% -{" "}
                                  {appliedCoupon.coupon})
                                </h3>
                              </div>
                              <div className="float-end">
                                <p className="text-success">- ₹ 0</p>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className="grand-total float-start w-100 mt-1">
                          <div className="float-start">
                            <h3 className="h4 font-weight-bold">
                              Payable Amount
                            </h3>
                          </div>
                          <div className="float-end">
                            <p>
                              <b>{`₹ ${total}`}</b>
                            </p>
                          </div>
                        </div>
                        {/* <div className="coupon-wrapper mt-1 border-bottom">
                      <div className="mb-1" onClick={toggleCoupon}>
                        <p className="mb-0">Have a coupon code?</p>
                      </div>
                      <div
                        className={`coupon-box mt-2 ${
                          showCoupon ? "show" : ""
                        }`}
                      >
                        <Input
                          type="text"
                          placeholder="Enter coupon code"
                          onChange={e =>
                            setCouponCode(e.target.value.toUpperCase())
                          }
                          value={couponCode}
                        />
                        <Button
                          className="btn-primary bg-primary btn text-white"
                          onClick={() => {
                            appliedCoupon ? removeCoupon() : applyCoupon()
                          }}
                        >
                          {appliedCoupon ? "Remove" : "Apply"}
                        </Button>
                      </div>
                      {appliedCouponError && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "0.8rem",
                            marginTop: "0",
                            marginBottom: "0.75rem",
                            lineHeight: "1.2",
                          }}
                        >
                          {appliedCouponError}
                        </div>
                      )}
                    </div> */}
                      </div>

                      <div className="clearfix"></div>
                      <div
                        className="tnc-wrapper mt-3 p-3"
                        style={{
                          border: tncAccepted
                            ? "2px solid #880356"
                            : "2px solid #f0a0cc",
                          borderRadius: 8,
                          background: tncAccepted ? "#fff0f8" : "#fff8fc",
                          transition: "border-color 0.2s, background 0.2s",
                        }}
                      >
                        <div className="d-flex align-items-start gap-2">
                          <input
                            type="checkbox"
                            id="tnc-checkbox"
                            checked={tncAccepted}
                            onChange={e => setTncAccepted(e.target.checked)}
                            style={{
                              width: 20,
                              height: 20,
                              marginTop: 2,
                              accentColor: "#880356",
                              cursor: "pointer",
                              flexShrink: 0,
                            }}
                          />
                          <label
                            htmlFor="tnc-checkbox"
                            style={{ cursor: "pointer", marginBottom: 0, fontSize: "0.88rem", lineHeight: 1.5 }}
                          >
                            The payment amount is{" "}
                            <strong>non-refundable</strong>. I have read and
                            agree to the{" "}
                            <a
                              href="https://pulapuneladies.com/terms-and-conditions/"
                              target="_blank"
                              rel="noreferrer"
                              style={{ color: "#880356", fontWeight: 600 }}
                            >
                              Terms and Conditions
                            </a>{" "}
                            and confirm my acceptance by proceeding with payment.
                          </label>
                        </div>
                        {!tncAccepted && (
                          <p className="mb-0 mt-2" style={{ fontSize: "0.78rem", color: "#880356" }}>
                            Please accept the terms and conditions to continue.
                          </p>
                        )}
                      </div>
                      {billingDetails.submitCount > 0 &&
                        !billingDetails.isValid && (
                          <div className="text-danger small mt-2">
                            ** Please fill out all required fields correctly
                            before booking. **
                          </div>
                        )}
                      <button
                        type="submit"
                        className="btn btn-primary w-100 mt-3"
                        disabled={
                          !tncAccepted ||
                          createOrderAwardNominationScreen.loading ||
                          verifyAwardNominationPaymentScreen.loading
                        }
                      >
                        {createOrderAwardNominationScreen.loading ||
                        verifyAwardNominationPaymentScreen.loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Please wait...
                          </>
                        ) : (
                          "PAY NOW"
                        )}
                      </button>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Form>
          </Container>
          <PageLoader
            open={
              createOrderAwardNominationScreen.loading ||
              verifyAwardNominationPaymentScreen.loading
            }
          />
        </div>
      </div>
    </div>
  )
}

export default AwardBillingDetails
